import { module } from "angular";
import { ErrorComponent } from "./ErrorComponent";

module("mmGui").component("mmError", new ErrorComponent());
